import { useEffect } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import { selectUserInfo } from "appredux/user/userSlice";
import { useSelector } from "react-redux";

export function useIntercom() {
  const userInfo = useSelector(selectUserInfo);

  useEffect(() => {
    const auth = localStorage.getItem("auth");

    /**
     * @description
     * Initialize Intercom for anonymous users
     */
    if (!auth) {
      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      });
    }
  }, []);

  useEffect(() => {
    /**
     * @description
     * Wait for userInfo to be loaded before initializing Intercom
     */
    if (userInfo?.email) {
      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        user_id: userInfo?.email,
        email: userInfo.email,
        name: `${userInfo?.firstname} ${userInfo?.lastname}`,
        verified_email: userInfo?.verified,
        usefId: userInfo?.usefId,
        is_usef_member_discount_selected:
          userInfo?.selected_plan_data?.is_usef_member_discount_selected,
        max_horses: userInfo?.max_horses,
      });
    }
  }, [userInfo?.email]);
}
